// routers/index.ts（或你的原文件名）
import _ from 'lodash';

// 假设全局已有 ReactRoute 类型；否则可自行定义：
// type ReactRoute = { path: string; children?: ReactRoute[]; [k: string]: any };

/** 拼接路径，避免出现重复/缺失斜杠 */
const joinPath = (base: string, sub: string) => {
    const a = base.replace(/\/+$/, '');
    const b = sub.replace(/^\/+/, '');
    return `${a}/${b}`;
};

/** 深度合并：把 children 展平成一维，并把子路由 path 拼到父 path 后 */
const __mergeRoutes = (routes: ReactRoute[]): ReactRoute[] => {
    const __list: ReactRoute[] = [];
    routes.forEach((o) => {
        __list.push(o);
        if (_.isArray(o.children)) {
            const __children = __mergeRoutes(o.children);
            __children.forEach((m) => {
                __list.push({
                    ...m,
                    path: joinPath(o.path, m.path),
                });
            });
        }
    });
    return __list;
};

// 同目录下 *.tsx（非递归）；若需要递归改成 './**/*.tsx'
const modules = import.meta.glob<ReactRoute[]>('./*.tsx', {
    eager: true,
    import: 'default',
}) as Record<string, ReactRoute[]>;

let routers: ReactRoute[] = [];

// 稳定按文件名排序，且跳过 index.tsx / index.ts
Object.keys(modules)
    .filter((p) => !/\/index\.(tsx|ts)$/.test(p))
    .sort()
    .forEach((p) => {
        const list = modules[p];
        if (!Array.isArray(list)) {
            throw new Error(`router file ${p} is not array`);
        }
        const merged = __mergeRoutes(list);
        // 保持你原本的“前置”合并顺序
        routers = [...merged, ...routers];
    });

export default routers;
